module.exports = __webpack_public_path__ + "img/copyRight.d0289dc0.png";